import React from 'react';
import styled from 'styled-components';
import DangerSrc from './images/danger.png';
import WarningSrc from './images/warning.png';
import { AvatarColors } from '../../theme/tokens';

const IconBackdrop = styled.div<{ type: 'danger' | 'warning' }>`
  width: 48px;
  height: 48px;
  border-radius: 24px;
  background-color: ${(props) =>
    props.type === 'danger'
      ? AvatarColors[7].background
      : AvatarColors[2].background};

  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom 16px;
`;

const IconImg = styled.img`
  margin-bottom: 1px;
`;

const Icon = ({ type }: { type: 'danger' | 'warning' }) => (
  <IconBackdrop type={type}>
    <IconImg src={type === 'danger' ? DangerSrc : WarningSrc} />
  </IconBackdrop>
);

export default Icon;
